/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file
 */


/**
 * The routes
 *
 * @type {object} The routes
 */
export default [
  // Home
  {
    path: '/home',
    name: 'home.index',
    component: require('./pages/home/index/index.vue'),

    // If the user needs to be guest to view this page
    meta: {
      guest: true,
    },
  },
  // Release notes
  {
    path: '/release-notes',
    name: 'home.release-notes',
    component: require('./pages/home/releaseNotes/releaseNotes.vue'),
  },

  // Newsletter unsubscribe response.
  {
    path: '/unsubscribed',
    name: 'home.unsubscribed',
    component: require('./pages/home/unsubscribed/unsubscribed.vue'),
  },

  // Login as user
  {
    path: '/login-using-token/:token',
    name: 'login.using.token',
    component: require('./pages/home/loginUsingToken/loginUsingToken.vue'),

    // If the user needs to be guest to view this page
    meta: {
      guest: true,
    },
  },

  // Register routes
  {
    path: '/register/:plan',
    name: 'register.emailSetup',
    component: require('./pages/register/emailSetup/emailSetup.vue'),

    // If the user needs to be guest to view this page
    meta: {
      guest: true,
    },
  },
  // {
  //   path: '/register',
  //   component: require('./pages/register/register.vue'),
  //   children: [
  //     {
  //       path: 'email/:plan',
  //       name: 'register.emailSetup',
  //       component: require('./pages/register/emailSetup/emailSetup.vue'),

  //       // If the user needs to be authenticated to view this page
  //       meta: {
  //         auth: false,
  //       },
  //     },
  //     {
  //       path: 'account-setup/:plan',
  //       name: 'register.accountSetup',
  //       component: require('./pages/register/accountSetup/accountSetup.vue'),

  //       // If the user needs to be authenticated to view this page
  //       meta: {
  //         auth: false, // Should be true once done editing the design for this page.
  //       },
  //     },
  //     {
  //       path: 'account-setup/:id',
  //       component: require('./pages/register/accountSetup/accountSetup.vue'),

  //       // If the user needs to be authenticated to view this page
  //       meta: {
  //         auth: false,
  //       },
  //     },
  //     {
  //       path: 'personal-info',
  //       name: 'register.personalInfo',
  //       component: require('./pages/register/personalInfo/personalInfo.vue'),

  //       // If the user needs to be authenticated to view this page
  //       meta: {
  //         auth: false,
  //       },
  //     },
  //     {
  //       path: 'completed',
  //       name: 'register.done',
  //       component: require('./pages/register/registerDone/registerDone.vue'),

  //       // If the user needs to be authenticated to view this page
  //       meta: {
  //         auth: true,
  //       },
  //     },
  //   ],
  // },

  // Login
  {
    path: '/login',
    name: 'auth.login',
    component: require('./pages/auth/login/login.vue'),

    // If the user needs to be guest to view this page
    meta: {
      guest: true,
    },
  },

  // Password reset
  {
    path: '/reset-password',
    name: 'auth.resetPassword',
    component: require('./pages/auth/resetPassword/resetPassword.vue'),

    // If the user needs to be guest to view this page
    meta: {
      guest: true,
    },
  },

  // verify two factor auth
  {
    path: '/verify-code',
    name: 'auth.twoFactorVerification',
    component: require('./pages/auth/twoFactorVerification/twoFactorVerification.vue'),

    // If the user needs to be guest to view this page
    meta: {
      guest: true,
    },
  },

  // Components with the navigation wrapper.
  {
    path: '',
    component: require('./pages/withNavigation/navigation.vue'),
    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
    children: [

      // Dashboard
      {
        path: '',
        name: 'dashboard',
        component: require('./pages/withNavigation/dashboard/dashboard.vue'),
      },


      // Reports
      {
        path: '/reports',
        name: 'reports',
        component: require('./pages/withNavigation/reports/reports.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Client',
            'Order',
          ],
        },
      },
      // Excise Reports
      {
        path: '/reports/excise/:id',
        name: 'exciseMonthlyReport',
        component: require('./pages/withNavigation/exciseReport/exciseReport.vue'),
        meta: {
          emailVerificationRequired: true,
        },
      },

      // Profile routes
      {
        path: '/profile',
        component: require('./pages/withNavigation/profile/profile.vue'),
        children: [
          {
            path: 'account',
            name: 'profile.account',
            component: require('./pages/withNavigation/profile/account/account.vue'),
          },
          {
            path: 'address',
            name: 'profile.address',
            component: require('./pages/withNavigation/profile/address/address.vue'),
          },
          {
            path: 'contact',
            name: 'profile.contact',
            component: require('./pages/withNavigation/profile/contact/contact.vue'),
          },
          {
            path: 'public',
            name: 'publicProfile',
            component: require('./pages/withNavigation/profile/publicProfile/publicProfile.vue'),
            meta: {
              requiredModules: [
                'Order',
                'Appointment',
              ],
            },
          },
        ],
      },

      // Settings route
      {
        path: 'settings',
        name: 'application.settings',
        component: require('./pages/withNavigation/profile/settings/settings.vue'),

        // If the user needs to be authenticated to view this page
        meta: {
          auth: true,
        },
      },


          // Clients
      {
        path: '/clients',
        component: require('./pages/withNavigation/clients/clients.vue'),
        meta: {
          requiredModules: [
            'Client',
          ],
        },
        children: [
          {
            path: '',
            name: 'clients.index',
            component: require('./pages/withNavigation/clients/index/index.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'all',
            },
          },
          {
            path: 'later',
            name: 'clients.later',
            component: require('./pages/withNavigation/clients/index/index.vue'),
            // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'later',
            },
          },
          {
            path: 'pastMonth',
            name: 'clients.pastMonth',
            component: require('./pages/withNavigation/clients/index/index.vue'),
            // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'pastMonth',
            },
          },
          {
            path: 'create',
            name: 'clients.create',
            component: require('./pages/withNavigation/clients/create/create.vue'),
          },
          {
            path: ':id/edit',
            name: 'clients.edit',
            component: require('./pages/withNavigation/clients/edit/edit.vue'),
          },
        ],
      },

      // Pricing agreements (customer discount agreements)
      {
        path: '/pricing-agreements',
        component: require('./pages/withNavigation/pricingAgreements/pricingAgreements.vue'),
        meta: {
          requiredModules: ['Client'],
        },
        children: [
          {
            path: '',
            name: 'pricingAgreements.index',
            component: require('./pages/withNavigation/pricingAgreements/index/index.vue'),
            meta: { auth: true },
          },
          {
            path: 'create',
            name: 'pricingAgreements.create',
            component: require('./pages/withNavigation/pricingAgreements/create/create.vue'),
            meta: { auth: true },
          },
          {
            path: ':id/edit',
            name: 'pricingAgreements.edit',
            component: require('./pages/withNavigation/pricingAgreements/edit/edit.vue'),
            meta: { auth: true },
          },
        ],
      },

      // Supplier
      {
        path: '/suppliers',
        component: require('./pages/withNavigation/supplier/supplier.vue'),
        meta: {
          requiredModules: [
            'Supplier',
          ],
        },
        children: [
          {
            path: '',
            name: 'supplier.index',
            component: require('./pages/withNavigation/supplier/index/index.vue'),
                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'all',
            },
          },
          {
            path: 'create',
            name: 'supplier.create',
            component: require('./pages/withNavigation/supplier/create/create.vue'),
          },
          {
            path: ':id/edit',
            name: 'supplier.edit',
            component: require('./pages/withNavigation/supplier/edit/edit.vue'),
          },
        ],
      },

     /* // warehouse
      {
        path: '/warehouses',
        component: require('./pages/withNavigation/warehouse/warehouse.vue'),
        meta: {
          requiredModules: [
            'Warehouse',
          ],
        },
        children: [
          {
            path: '',
            name: 'warehouse.index',
            component: require('./pages/withNavigation/warehouse/index/index.vue'),
                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'all',
            },
          },
          {
            path: 'create',
            name: 'warehouse.create',
            component: require('./pages/withNavigation/warehouse/create/create.vue'),
          },
          {
            path: ':id/edit',
            name: 'warehouse.edit',
            component: require('./pages/withNavigation/warehouse/edit/edit.vue'),
          },
        ],
      },*/

      // Client Groups
      {
        path: '/client-groups',
        component: require('./pages/withNavigation/clientGroups/clientGroups.vue'),
        meta: {
          requiredModules: [
            'Client',
          ],
        },
        children: [
          {
            path: '',
            name: 'clientGroups.index',
            component: require('./pages/withNavigation/clientGroups/index/index.vue'),
          },
          {
            path: 'later',
            name: 'clientGroups.later',
            component: require('./pages/withNavigation/clientGroups/index/index.vue'),
            // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'later',
            },
          },
          {
            path: 'pastMonth',
            name: 'clientGroups.pastMonth',
            component: require('./pages/withNavigation/clientGroups/index/index.vue'),
            // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'pastMonth',
            },
          },
          {
            path: 'create',
            name: 'clientGroups.create',
            component: require('./pages/withNavigation/clientGroups/create/create.vue'),
          },
          {
            path: ':id/edit',
            name: 'clientGroups.edit',
            component: require('./pages/withNavigation/clientGroups/edit/edit.vue'),
          },
        ],
      },

      // Production
      {
        path: '/production',
        component: require('./pages/withNavigation/materials/materials.vue'),
        meta: {
          emailVerificationRequired: true,
        },
        children: [
          {
            path: '/production/materials',
            name: 'production.materials.index',
            component: require('./pages/withNavigation/materials/index/index.vue'),
          },
          {
            path: '/production/materials/create',
            name: 'production.materials.create',
            component: require('./pages/withNavigation/materials/create/create.vue'),
          },
          {
            path: '/production/materials/:id/view',
            name: 'production.materials.view',
            component: require('./pages/withNavigation/materials/edit/edit.vue'),
          },
          {
            path: '/production/materials/:id/edit',
            name: 'production.materials.edit',
            component: require('./pages/withNavigation/materials/edit/edit.vue'),
          },
          // Batches
          {
            path: '/production/batches',
            name: 'production.batches.index',
            component: require('./pages/withNavigation/batches/index/index.vue'),
          },
          {
            path: '/production/batches/create',
            name: 'production.batches.create',
            component: require('./pages/withNavigation/batches/create/create.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'production.batches.index',
              },
            },
          },
          {
            path: '/production/batches/:id/view',
            name: 'production.batches.view',
            component: require('./pages/withNavigation/batches/view/view.vue'),
          },
          {
            path: '/production/batches/:id/edit',
            name: 'production.batches.edit',
            component: require('./pages/withNavigation/batches/edit/edit.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'production.batches.view',
                preserveParams: true,
              },
            },
          },
          // Recipe
          {
            path: '/production/recipes',
            name: 'production.recipes.index',
            component: require('./pages/withNavigation/recipes/index/index.vue'),
          },
          {
            path: '/production/recipes/create',
            name: 'production.recipes.create',
            component: require('./pages/withNavigation/recipes/create/create.vue'),
          },
          {
            path: '/production/recipes/:id/view',
            name: 'production.recipes.view',
            component: require('./pages/withNavigation/recipes/edit/edit.vue'),
          },
          {
            path: '/production/recipes/:id/edit',
            name: 'production.recipes.edit',
            component: require('./pages/withNavigation/recipes/edit/edit.vue'),
          },
          // Equipment
          {
            path: '/production/equipments',
            name: 'production.equipments.index',
            component: require('./pages/withNavigation/equipments/index/index.vue'),
          },
          {
            path: '/production/equipments/create',
            name: 'production.equipments.create',
            component: require('./pages/withNavigation/equipments/create/create.vue'),
          },
          {
            path: '/production/equipments/:id/view',
            name: 'production.equipments.view',
            component: require('./pages/withNavigation/equipments/edit/edit.vue'),
          },
          {
            path: '/production/equipments/:id/edit',
            name: 'production.equipments.edit',
            component: require('./pages/withNavigation/equipments/edit/edit.vue'),
          },
        ],
      },

      // Products
      {
        path: '/products',
        component: require('./pages/withNavigation/products/products.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Product',
          ],
        },
        children: [
          {
            path: '',
            name: 'products.index',
            component: require('./pages/withNavigation/products/index/index.vue'),
          },
          {
            path: 'create',
            name: 'products.create',
            component: require('./pages/withNavigation/products/create/create.vue'),
          },
          {
            path: 'syncvmp',
            name: 'products.syncVmp',
            component: require('./pages/withNavigation/products/syncVmp/syncVmp.vue'),
          },
          {
            path: ':id/edit',
            name: 'products.edit',
            component: require('./pages/withNavigation/products/edit/edit.vue'),
          },
          {
            path: '/productflow',
            name: 'productFlow.index',
            component: require('./pages/withNavigation/productFlow/index/index.vue'),
                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'all',
            },
          },
          {
            path: '/productflow/create',
            name: 'productFlow.create',
            component: require('./pages/withNavigation/productFlow/create/create.vue'),
          },
          {
            path: '/productflow/:id/edit',
            name: 'productFlow.edit',
            component: require('./pages/withNavigation/productFlow/edit/edit.vue'),
          },
          {
            path: '/exciseentry',
            name: 'exciseentry.index',
            component: require('./pages/withNavigation/exciseEntry/index/index.vue'),
          },
        ],
      },


      // Members route
      {
        path: '/members',
        name: 'members',
        component: require('./pages/withNavigation/members/members.vue'),

        children: [
          {
            path: '',
            name: 'members.index',
            component: require('./pages/withNavigation/members/index/index.vue'),
          },
          {
            path: ':id',
            name: 'members.show',
            component: require('./pages/withNavigation/members/show/show.vue'),
          },
        ],

        // If the user needs to be authenticated to view this page
        meta: {
          auth: true,
        },
      },

      // Membership route
      {
        path: '/membership',
        name: 'membership',
        component: require('./pages/withNavigation/membership/membership.vue'),

        children: [
          {
            path: '',
            name: 'membership.index',
            component: require('./pages/withNavigation/membership/index/index.vue'),
          },
          {
            path: ':id',
            name: 'membership.show',
            component: require('./pages/withNavigation/membership/show/show.vue'),
          },
        ],

        // If the user needs to be authenticated to view this page
        meta: {
          auth: true,
        },
      },

      // Product Groups
      {
        path: '/product-groups',
        component: require('./pages/withNavigation/productGroups/productGroups.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Product',
          ],
        },
        children: [{
          path: '',
          name: 'productGroups.index',
          component: require('./pages/withNavigation/productGroups/index/index.vue'),
        },
        {
          path: 'create',
          name: 'productGroups.create',
          component: require('./pages/withNavigation/productGroups/create/create.vue'),
        },
        {
          path: ':id/edit',
          name: 'productGroups.edit',
          component: require('./pages/withNavigation/productGroups/edit/edit.vue'),
        },
        ],
      },

      // Product Bundle
      {
        path: '/product-bundles',
        component: require('./pages/withNavigation/productBundles/productBundles.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Product',
          ],
        },
        children: [{
          path: '',
          name: 'productBundles.index',
          component: require('./pages/withNavigation/productBundles/index/index.vue'),
        },
        {
          path: 'create',
          name: 'productBundles.create',
          component: require('./pages/withNavigation/productBundles/create/create.vue'),
        },
        {
          path: ':id/edit',
          name: 'productBundles.edit',
          component: require('./pages/withNavigation/productBundles/edit/edit.vue'),
        }],
      },

      // Product Packaging
      {
        path: '/product-packagings',
        component: require('./pages/withNavigation/productPackagings/productPackagings.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Product',
          ],
        },
        children: [{
          path: '',
          name: 'productPackagings.index',
          component: require('./pages/withNavigation/productPackagings/index/index.vue'),
        },
        {
          path: 'create',
          name: 'productPackagings.create',
          component: require('./pages/withNavigation/productPackagings/create/create.vue'),
        },
        {
          path: ':id/edit',
          name: 'productPackagings.edit',
          component: require('./pages/withNavigation/productPackagings/edit/edit.vue'),
        },
        ],
      },
      // Product Tags
      {
        path: '/product-tags',
        component: require('./pages/withNavigation/productTag/productTag.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Product',
          ],
        },
        children: [
          {
            path: '',
            name: 'productTags.index',
            component: require('./pages/withNavigation/productTag/index/index.vue'),
          },
          {
            path: 'create',
            name: 'productTags.create',
            component: require('./pages/withNavigation/productTag/create/create.vue'),
          },
          {
            path: ':id/edit',
            name: 'productTags.edit',
            component: require('./pages/withNavigation/productTag/edit/edit.vue'),
          },
        ],
      },

           // Price Fields
      {
        path: '/price-fields',
        component: require('./pages/withNavigation/priceFields/priceFields.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Product',
          ],
        },
        children: [
          {
            path: '',
            name: 'priceFields.index',
            component: require('./pages/withNavigation/priceFields/index/index.vue'),
          },
          {
            path: 'create',
            name: 'priceFields.create',
            component: require('./pages/withNavigation/priceFields/create/create.vue'),
          },
          {
            path: ':id/edit',
            name: 'priceFields.edit',
            component: require('./pages/withNavigation/priceFields/edit/edit.vue'),
          },
        ],
      },

          // Unit of measures
      {
        path: '/unit-of-measure',
        component: require('./pages/withNavigation/unitOfMeasure/unitOfMeasure.vue'),
        meta: {
          requiredModules: [
            'UnitOfMeasure',
          ],
        },
        children: [
          {
            path: '',
            name: 'unitOfMeasure.index',
            component: require('./pages/withNavigation/unitOfMeasure/index/index.vue'),
          },
          {
            path: 'create',
            name: 'unitOfMeasure.create',
            component: require('./pages/withNavigation/unitOfMeasure/create/create.vue'),
          },
          {
            path: ':id/edit',
            name: 'unitOfMeasure.edit',
            component: require('./pages/withNavigation/unitOfMeasure/edit/edit.vue'),
          },
        ],
      },

      // Inventory
      {
        path: '/inventory',
        component: require('./pages/withNavigation/stock/stock.vue'),
        meta: {
          requiredModules: [
            'Inventory',
          ],
        },
        children: [
          {
            path: '/inventory/stocks',
            name: 'inventory.stock.index',
            component: require('./pages/withNavigation/stock/index/index.vue'),
          },
          {
            path: '/inventory/stocks/create',
            name: 'inventory.stock.create',
            component: require('./pages/withNavigation/stock/create/create.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.stock.index',
              },
            },
          },
          {
            path: '/inventory/stocks/:id/view',
            name: 'inventory.stock.view',
            component: require('./pages/withNavigation/stock/view/view.vue'),
          },
          {
            path: '/inventory/stocks/:id/edit',
            name: 'inventory.stock.edit',
            component: require('./pages/withNavigation/stock/edit/edit.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.stock.view',
                preserveParams: true,
              },
            },
          },
          {
            path: '/inventory/adjustment',
            name: 'inventory.adjustment.index',
            component: require('./pages/withNavigation/adjustment/index/index.vue'),
          },
          {
            path: '/inventory/adjustment/create/stock',
            name: 'inventory.adjustment.stock.create',
            component: require('./pages/withNavigation/adjustment/stock/create/create.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.adjustment.index',
              },
            },
          },
          {
            path: '/inventory/adjustment/:id/view',
            name: 'inventory.adjustment.view',
            component: require('./pages/withNavigation/adjustment/view/view.vue'),
          },
          {
            path: '/inventory/adjustment/stock/:id/edit',
            name: 'inventory.adjustment.stock.edit',
            component: require('./pages/withNavigation/adjustment/stock/edit/edit.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.adjustment.view',
                preserveParams: true,
              },
            },
          },
          {
            path: '/inventory/purchase',
            name: 'inventory.purchase.index',
            component: require('./pages/withNavigation/purchase/index/index.vue'),
          },
          {
            path: '/inventory/purchase/create',
            name: 'inventory.purchase.create',
            component: require('./pages/withNavigation/purchase/create/create.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.purchase.index',
              },
            },
          },
          {
            path: '/inventory/purchase/:id/view',
            name: 'inventory.purchase.view',
            component: require('./pages/withNavigation/purchase/view/view.vue'),
          },
          {
            path: '/inventory/purchase/:id/edit',
            name: 'inventory.purchase.edit',
            component: require('./pages/withNavigation/purchase/edit/edit.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.purchase.view',
                preserveParams: true,
              },
            },
          },
          {
            path: '/inventory/purchase/:id/receipt',
            name: 'inventory.purchase.receipt',
            component: require('./pages/withNavigation/purchase/receipt/receipt.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.purchase.view',
                preserveParams: true,
              },
            },
          },
          {
            path: '/inventory/transfer',
            name: 'inventory.transfer.index',
            component: require('./pages/withNavigation/transfer/index/index.vue'),
          },
          {
            path: '/inventory/transfer/create',
            name: 'inventory.transfer.create',
            component: require('./pages/withNavigation/transfer/create/create.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.transfer.index',
              },
            },
          },
          {
            path: '/inventory/transfer/:id/view',
            name: 'inventory.transfer.view',
            component: require('./pages/withNavigation/transfer/view/view.vue'),
          },
          {
            path: '/inventory/transaction',
            name: 'inventory.transaction.index',
            component: require('./pages/withNavigation/transaction/index/index.vue'),
            meta: {
              inventoryBridgeStockWrite: true,
              inventoryBridgeFallback: {
                name: 'inventory.stock.index',
              },
            },
          },
          {
            path: '/inventory/warehouse',
            name: 'warehouse.index',
            component: require('./pages/withNavigation/warehouse/index/index.vue'),
                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
              subMenu: 'all',
            },
          },
          {
            path: '/inventory/warehouse/create',
            name: 'warehouse.create',
            component: require('./pages/withNavigation/warehouse/create/create.vue'),
          },
          {
            path: '/inventory/warehouse/:id/edit',
            name: 'warehouse.edit',
            component: require('./pages/withNavigation/warehouse/edit/edit.vue'),
          },
        ],
      },

          // Campaigns
      {
        path: '/campaigns',
        component: require('./pages/withNavigation/campaigns/campaigns.vue'),
        children: [
          {
            path: '',
            name: 'campaigns.index',
            component: require('./pages/withNavigation/campaigns/index/index.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
          {
            path: 'create',
            name: 'campaigns.create',
            component: require('./pages/withNavigation/campaigns/create/create.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
          {
            path: ':id/edit',
            name: 'campaigns.edit',
            component: require('./pages/withNavigation/campaigns/edit/edit.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
          {
            path: ':id/create-email',
            name: 'campaigns.createEmail',
            component: require('./pages/withNavigation/news/create/create.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
          {
            path: ':id/email/:newsId',
            name: 'campaigns.editEmail',
            component: require('./pages/withNavigation/news/edit/edit.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
        ],
      },

      // Subscribe Lists
      {
        path: '/subscriberList',
        component: require('./pages/withNavigation/subscriberList/subscriberList.vue'),
        children: [
          {
            path: '',
            name: 'subscriberList.index',
            component: require('./pages/withNavigation/subscriberList/index/index.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
          {
            path: 'create',
            name: 'subscriberList.create',
            component: require('./pages/withNavigation/subscriberList/create/create.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
          {
            path: ':id/edit',
            name: 'subscriberList.edit',
            component: require('./pages/withNavigation/subscriberList/edit/edit.vue'),

                // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
        ],
      },

      // OrderPickup
      {
        path: '/orders/order-pickups',
        component: require('./pages/withNavigation/orderPickups/orderPickups.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            // 'Order',
            // 'OrderPickup',
          ],
        },
        children: [
          {
            path: '',
            name: 'orderPickups.index',
            component: require('./pages/withNavigation/orderPickups/index/index.vue'),
          },
        ],
      },

      // Orders
      {
        path: '/orders',
        component: require('./pages/withNavigation/orders/orders.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Order',
          ],
        },
        children: [
          {
            path: '',
            name: 'orders.index',
            component: require('./pages/withNavigation/orders/index/index.vue'),
          },
          {
            path: 'create',
            name: 'orders.create',
            component: require('./pages/withNavigation/orders/create/create.vue'),
          },
          {
            path: ':id/edit',
            name: 'orders.edit',
            component: require('./pages/withNavigation/orders/edit/edit.vue'),
          },
        ],
      },

      // Appointments
      {
        path: '/appointments',
        component: require('./pages/withNavigation/appointments/appointments.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Order',
            'Appointment',
          ],
        },
        children: [
          {
            path: '',
            name: 'appointments.index',
            component: require('./pages/withNavigation/appointments/index/index.vue'),
          },
        ],
      },

      // EDI Order
      {
        path: '/edi-orders',
        component: require('./pages/withNavigation/orders/orders.vue'),
        children: [
          {
            path: '',
            name: 'ediOrders.index',
            component: require('./pages/withNavigation/orders/index/index.vue'),

            // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
        ],
      },

      // Modules
      {
        path: '/modules',
        component: require('./pages/withNavigation/modules/modules.vue'),
        children: [
          {
            path: '',
            name: 'modules.index',
            component: require('./pages/withNavigation/modules/index/index.vue'),

            // If the user needs to be authenticated to view this page
            meta: {
              auth: true,
            },
          },
        ],
      },

      {
        path: 'bills',
        component: require('./pages/withNavigation/bills/bills.vue'),
        meta: {
          emailVerificationRequired: true,
          requiredModules: [
            'Order',
          ],
        },
        children: [
          {
            path: '',
            name: 'bills.index',
            component: require('./pages/withNavigation/bills/index/index.vue'),
          },
          {
            path: 'create',
            name: 'bills.create',
            component: require('./pages/withNavigation/bills/create/create.vue'),
          },
          {
            path: 'export',
            name: 'bills.export',
            component: require('./pages/withNavigation/bills/export/export.vue'),
          },
          {
            path: ':id/edit',
            name: 'bills.edit',
            component: require('./pages/withNavigation/bills/edit/edit.vue'),
          },
          {
            path: ':id/credit-note',
            name: 'bills.creditNote',
            component: require('./pages/withNavigation/bills/edit/edit.vue'),
          },
        ],
      },
    ],
  },

  {
    path: '/*',
    redirect: '/home',
  },
];



// WEBPACK FOOTER //
// ./src/app/routes.js